module.exports = __webpack_public_path__ + "static/manutenzione.9e296d21.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/manutenzione.png
// module id = 679
// module chunks = 115786611955454